module.exports = __webpack_public_path__ + "img/second.2862d0f3.png";